var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',_vm._g(_vm._b({attrs:{"v-model":_vm.currentPage,"size":_vm.size,"align":_vm.align,"total-rows":_vm.totalRows,"per-page":_vm.perPage}},'b-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }